/* eslint-disable node/no-deprecated-api */
import {channelTypes} from '@divvit/common-channels'
import ChannelGroupTitle from 'components/ChannelGroupTitle'
import ChannelTitle from 'components/ChannelTitle'
import Checkbox from 'components/Checkbox'
import {Cell, Column, Table} from 'components/Table'
import * as _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {
  fetchReferrerMappings,
  removeReferrerMappings
} from 'redux/modules/settings/actions'
import {getReferrerMappings} from 'redux/modules/settings/selectors'

export class MappedView extends React.Component {
  static propTypes = {
    fetchReferrerMappings: PropTypes.func,
    removeReferrerMappings: PropTypes.func,
    referrerMappings: PropTypes.array,
    isReferrerMappingFetching: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedMappings: []
    }
  }

  componentWillMount() {
    const {fetchReferrerMappings} = this.props
    fetchReferrerMappings()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      selectedMappings: []
    })
  }

  render() {
    return (
      <div className='mapped-view'>
        <div className='mapped-view_intro'>
          Below are the rules that were created.
          <i className='mapped-view_intro_desc'>
            If any mapping in this section get removed, it only could show up at
            Unmapped section for re-mapping if there were data which associate
            with it received during the last 02 months.
          </i>
        </div>
        {this.renderMappedRulesTable()}
      </div>
    )
  }

  renderMappedRulesTable() {
    const {referrerMappings, isReferrerMappingFetching} = this.props
    const {selectedMappings} = this.state
    const disabled = selectedMappings.length === 0
    return (
      <form className='mapped-view_edit-form' onSubmit={this.handleSubmit}>
        <Table
          data={referrerMappings}
          loading={isReferrerMappingFetching}
          empty='No mappings'
        >
          <Column
            header='Channel Type'
            grow
            cell={data => (
              <Cell>
                {channelTypes[data.channel.dv_chtype]?.label ||
                  data.channel.dv_chtype}
              </Cell>
            )}
          />
          <Column
            header='Channel Group'
            grow
            cell={data => (
              <Cell>
                <ChannelGroupTitle id={data.channel.dv_chgroup} />
              </Cell>
            )}
          />
          <Column
            header='Channel'
            grow
            cell={data => (
              <Cell>
                <ChannelTitle id={data.channel.dv_channel} iconSize='16px' />
              </Cell>
            )}
          />
          <Column
            header='Referrer'
            grow
            cell={data => (
              <Cell>
                {data.regexMappings.map((regexMapping, index) => {
                  const key = data._id + index
                  const item = {key, _id: data._id, regexMapping, index}
                  return (
                    <div key={key} className='mapped-url'>
                      <span>{regexMapping.referer}</span>
                      <Checkbox
                        checked={!!_.find(selectedMappings, {key})}
                        onChange={checked => this.onSelect(item, checked)}
                      />
                    </div>
                  )
                })}
              </Cell>
            )}
          />
        </Table>
        <div className='mapped-view_edit-form_button'>
          <button className='is-red' disabled={disabled} type='submit'>
            Remove Selected
          </button>
        </div>
      </form>
    )
  }

  onSelect = (data, checked) => {
    const {selectedMappings} = this.state
    const itemIndex = _.findIndex(selectedMappings, {key: data.key})
    const isSelected = itemIndex > -1

    if (checked) {
      this.setState({
        selectedMappings: !isSelected
          ? [...selectedMappings, data]
          : selectedMappings
      })
    } else if (isSelected) {
      this.setState({
        selectedMappings: [
          ...selectedMappings.splice(0, itemIndex),
          ...selectedMappings.slice(itemIndex + 1)
        ]
      })
    }
  }

  handleSubmit = evt => {
    evt.preventDefault()
    const {selectedMappings} = this.state
    const {removeReferrerMappings} = this.props
    removeReferrerMappings(selectedMappings)
  }
}

const mapStateToProps = state => ({
  referrerMappings: getReferrerMappings(state),
  isReferrerMappingFetching: state.settings.isReferrerMappingFetching
})

export default connect(mapStateToProps, {
  fetchReferrerMappings,
  removeReferrerMappings
})(MappedView)



// WEBPACK FOOTER //
// ./client/views/SettingsReferrerMappingView/MappedView.js